import {FaIcon, DetailsSection, DetailsRow} from "client/js/util/layout_utils";

const TrafficCard = (props) => {
  const traffic = props.traffic;
  const used_percent = traffic.prorated_limit ? (traffic.net_external_in + traffic.net_external_out) / traffic.prorated_limit * 100 : null;

  return (
    <DetailsSection title="Traffic">
      {!!used_percent && (
        <DetailsRow title="Traffic-Verbrauch">
          <div className="progress">
            <div className="progress-bar" style={{ "width": `${used_percent}%` }}>
              {(traffic.net_external_in + traffic.net_external_out).fileSize()}/{traffic.prorated_limit.fileSize()} ({used_percent.toFixed(2)}%)
            </div>
          </div>
        </DetailsRow>
      )}

      <DetailsRow title="Limit">
          {traffic.limit ? traffic.limit.fileSize() : 'kein Limit'}
          {traffic.prorated_limit && traffic.prorated_limit != traffic.limit ? ` (${traffic.prorated_limit.fileSize()} anteilig)` : null}
      </DetailsRow>

      <DetailsRow title="Externer Traffic">
        {traffic.net_external_in.fileSize()} <FaIcon name="download" title="eingehender Traffic" /> / {traffic.net_external_out.fileSize()} <FaIcon name="upload" title="ausgehender Traffic" />
      </DetailsRow>

      <DetailsRow title="Interner Traffic">
        {traffic.net_internal_in.fileSize()} <FaIcon name="download" title="eingehender Traffic" /> / {traffic.net_internal_out.fileSize()} <FaIcon name="upload" title="ausgehender Traffic" />
      </DetailsRow>
    </DetailsSection>
  )
};

const Overview = (props) => {
  const traffic = props.virtual_machine.traffic;

  return (
    <>
      <div className="row mb-3">
        <div className="col-12 col-md-6">
          <DetailsSection title="Hardware-Konfiguration">
            <DetailsRow title="vCores" text={props.virtual_machine.vcores} />
            <DetailsRow title="RAM" text={`${props.virtual_machine.memory_gb} GB`} />
            <DetailsRow title="SSD" text={`${props.virtual_machine.ssd_storage_gb} GB`} />
          </DetailsSection>
        </div>

        <div className="col-12 col-md-6">
          <TrafficCard traffic={traffic} />
        </div>
      </div>
    </>
  );
}

export default Overview;
